<template>
  <div
    id="destinations-filter"
    class="filters-search"
  >
    <BaseSearchInput
      v-model:input="searchTerm"
      :placeholder="placeholderText"
    />
    <template
      v-for="(row, index) in places"
      :key="index"
    >
      <div class="box-top vowel">
        <h2>{{ index }}</h2>
      </div>
      <div class="box-content">
        <div class="big-list">
          <template
            v-for="(row2, index2) in row"
            :key="index2"
          >
            <div class="column">
              <template
                v-for="country in row2"
                :key="country.name"
              >
                <div
                  class="category country"
                >
                  <div class="header">
                    <div class="section">
                      <a :href="`${country.url}`">
                        <div :class="`flag flag-${country.countryCode}`" />
                        <span class="destination-name">{{ country.name }}</span>
                      </a>
                    </div>
                  </div>
                  <ul class="sub">
                    <template
                      v-for="city in country.cities"
                      :key="city.name"
                    >
                      <li>
                        <a :href="city.url">{{ cityDisplayName(city.name) }}</a>
                      </li>
                    </template>
                  </ul>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { l, CITY_ALIASES, cityDisplayName } from '@utils/toolbox';
const props = defineProps(['destinations']);

const searchTerm = ref('');
const placeholderText = l('global.simplePhrases.search');

const filterPlaces = (destinations, searchTerm) => {
	const placesFiltered = {};

	for (const [column, rows] of Object.entries(destinations.columns)) {
		for (const [row, items] of Object.entries(rows)) {
			for (const item of items) {
				const didCountryNameMatch = item.name.toLowerCase().includes(searchTerm);
				const matchedCities = item.cities.filter((city) => {
					const alias = CITY_ALIASES[city.name]?.toLowerCase() ?? '';
					return city.name.toLowerCase().includes(searchTerm) || alias.includes(searchTerm);
				});

				if (didCountryNameMatch || matchedCities.length > 0) {
					if (!placesFiltered[column]) {
						placesFiltered[column] = {};
					}
					if (!placesFiltered[column][row]) {
						placesFiltered[column][row] = [];
					}
					const newItem = didCountryNameMatch ? item : { ...item, cities: matchedCities };
					placesFiltered[column][row].push(newItem);
				}
			}
		}
	}
	return placesFiltered;
};

const places = computed(() => {
	const searchTermLowerCase = searchTerm.value.toLowerCase();
	return filterPlaces(props.destinations, searchTermLowerCase);
});
</script>
